import { FC } from 'react';
import NumberUtil from 'utils/number';
import { CHART_COLORS } from './chartConfig';

interface MapTooltipProps {
  countryName: string;
  value: number;
  position: { x: number; y: number };
}

const MapTooltip: FC<MapTooltipProps> = ({ countryName, value, position }) => {
  return (
    <div
      className="tw-pointer-events-none tw-absolute tw-z-10"
      style={{
        left: position.x,
        top: position.y,
        transform: 'translate(-50%, -100%)',
      }}
    >
      <div className="tw-flex tw-items-center tw-gap-1 tw-rounded-lg tw-bg-grayscale-180 tw-px-3 tw-py-2 tw-shadow-lg">
        <span className="tw-text-sm tw-text-white">{countryName}</span>
        <span className="tw-text-sm tw-font-semibold tw-text-white">
          {NumberUtil.compact(value)}
        </span>
      </div>
      <div className="tw-flex tw-justify-center">
        <div
          className="tw-h-0 tw-w-0"
          style={{
            borderLeft: '6px solid transparent',
            borderRight: '6px solid transparent',
            borderTop: `6px solid ${CHART_COLORS.tooltipSurface}`,
          }}
        />
      </div>
    </div>
  );
};

export default MapTooltip;
